<ng-template #popContent>
  <div class="stock-status-content flex-container">
    <ul>
      <li *ngFor="let item of picklistItems">
        <span
          >Picklist #{{ item.picklist_id }} - {{ item.available_quantity }}</span
        >
      </li>
    </ul>
    <div class="total-quantity">Total: {{ getTotalQuantityAndIncrement() }}</div>
  </div>
</ng-template>
<div class="stock-status-warning">
  <button
    class="pick-list-total-popover"
    [ngbPopover]="popContent"
    *ngIf="getTotalQuantityAndIncrement() > 0"
  >
    <i class="fa fa-exclamation-triangle text-danger"></i>
  </button>
</div>
